import { formatCurrency } from '@angular/common';

import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {LazyLoadingData} from '../mapping-classes/lazy-loading-data';
import {ButtonData} from '../mapping-classes/button-data';
import {padEnd} from "lodash";

export class Creditcard implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'Rabo GoldCard';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.commercialProductTypeName || 'Rabo GoldCard';
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
      this.addButtons(response);
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];
      this.setPanels(response);
      this.setNameAndValues(response);
      this.addValues(response);
    }
  }

  setPanels(response) {
    const res = response.detailsViewObject;
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Passen'));
  }

  setNameAndValues(response?) {
    const cardsResponse = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.fillProductDetailsPanel(productDetailsPanel);
    const physicalCardsPanel: DetailPanel = this.panels[1];

    if ((cardsResponse.cards && cardsResponse.cards.length)
      || (cardsResponse.requestedCards && cardsResponse.requestedCards.length)) {
      this.addSubHeaderToPanel(physicalCardsPanel, 'Product afspraken');

      if (cardsResponse.cards && cardsResponse.cards.length) {
        this.addSubHeaderToPanel(physicalCardsPanel, 'Passen');
      }

      if (cardsResponse.requestedCards && cardsResponse.requestedCards.length) {
        this.addSubHeaderToPanel(physicalCardsPanel, 'Aanvragen passen / laatste PIN mailer');
      }

      if ((cardsResponse.cards && cardsResponse.cards.length) ||
        (cardsResponse.requestedCards && cardsResponse.requestedCards.length)) {
        this.fillPhysicalCardsPanel(physicalCardsPanel, response);
      }
    } else {
      this.addSubHeaderToPanel(physicalCardsPanel, 'Passen zijn nog niet verwerkt.');
    }

  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);

    const physicalCardsPanel: DetailPanel = this.panels[1];
    if ((obj.cards && obj.cards.length) ||
      (obj.requestedCards && obj.requestedCards.length)) {
      this.addValuesToPhysicalCardsPanel(physicalCardsPanel, obj);
    }
  }

  addButtons(response) {
    const data =  {
          arrangementNumber: response.detailsViewObject.arrangementNumber,
          administrationCode: response.detailsViewObject.administrationCode,
          commercialProductTypeCode: response.detailsViewObject.commercialProductTypeCode,
    };

    this.buttons.push(new ButtonData('productservicesurl', response.detailsViewObject['arrangementNumber'],
      response.detailsViewObject['administrationCode'], response.detailsViewObject['commercialProductTypeCode'],
      'Productservice'));

    this.buttons.push(new ButtonData(
       'cockpiturl',
       null,
       null,
       null,
       'B&O Cockpit',
       null,
       'boc-url', data));
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('arrangementNumber', new DetailLabel('Overeenkomstnummer'));
    productDetailsPanel.nameAndValues.set('status', new DetailLabel('Status'));
    productDetailsPanel.nameAndValues.set('accountNumber', new DetailLabel('Rekeningnummer'));
    productDetailsPanel.nameAndValues.set('firstName', new DetailLabel('Naam 1'));
    productDetailsPanel.nameAndValues.set('secondName', new DetailLabel('Naam 2'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('arrangementNumber').setValue(obj.arrangementNumber);
    productDetailsPanel.nameAndValues.get('status').setValue(obj.status);
    productDetailsPanel.nameAndValues.get('accountNumber').setValue(obj.accountNumber);
    productDetailsPanel.nameAndValues.get('firstName').setValue(obj.firstName);
    productDetailsPanel.nameAndValues.get('secondName').setValue(obj.secondName);
  }

  private fillPhysicalCardsPanel(physicalCardsPanel: DetailPanel, response?) {
    physicalCardsPanel.subPanels[0].nameAndValues.set('spendingLimit', new DetailLabel('Limiet card'));
    physicalCardsPanel.subPanels[0].nameAndValues.set('repaymentMethod', new DetailLabel('Betalingswijze'));
  }

  private addValuesToPhysicalCardsPanel(physicalCardsPanel: DetailPanel, obj) {

    let panelTableIndex = 1;
    const spendingLimit = (obj.spendingLimit || obj.spendingLimit === 0) ?
      formatCurrency(obj.spendingLimit, 'nl', '€')  : '-';
    const temporarySpendingLimitAmount = (obj.temporarySpendingLimitAmount || obj.temporarySpendingLimitAmount === 0) ?
      formatCurrency(obj.temporarySpendingLimitAmount, 'nl', '€') : '-';

    physicalCardsPanel.subPanels[0].nameAndValues.get('spendingLimit').setValue(spendingLimit);
    physicalCardsPanel.subPanels[0].nameAndValues.get('repaymentMethod').setValue(obj.repaymentMethod);

    if (obj.cards && obj.cards.length) {
      this.addTable(physicalCardsPanel, obj, 'cards', panelTableIndex);
    }

    if (obj.requestedCards && obj.requestedCards.length) {
      panelTableIndex = (obj.cards && obj.cards.length) ? panelTableIndex + 1 : panelTableIndex;
      this.addTable(physicalCardsPanel, obj, 'requestedcards', panelTableIndex);
    }
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }

  private addTable(panel: DetailPanel, obj, table, index) {

    // tslint:disable-next-line:no-shadowed-variable
    const tables = ( table ): string => {
      const tablesType = {
        cards: 'cards',
        requestedcards: 'requestedCards',
      };

      return tablesType[table];
    };

    panel.subPanels[index].hasTable = true;
    panel.subPanels[index].lazyLoadingData =
      new LazyLoadingData(null, null, table);

    if (obj[tables(table)] && obj[tables(table)].length !== 0) {
      obj[tables(table)].forEach((_table) => {
        _table.restrictedData = obj.restrictedData;
      });
      panel.subPanels[index].lazyLoadingData.data = obj[tables(table)];
    }
  }
}
